import SignIn from "../../component/signin/signin.component";

import "./loginpage.styles.css";

const LoginPage = () => (
  <div className="login-page">
    <SignIn />
  </div>
);

export default LoginPage;
